export default __webpack_public_path__ + "b384de9dcb17d301e883dd564749456a.png";